// extracted by mini-css-extract-plugin
module.exports = {"temperature-1":"EnvTemperature_temperature-1__2-6ir","temperature-2":"EnvTemperature_temperature-2__35wWd","temperature-3":"EnvTemperature_temperature-3__2O2Kl"};